import { render } from "./MainWithoutFooterLayout.vue?vue&type=template&id=64b15fe3"
import script from "./MainWithoutFooterLayout.vue?vue&type=script&lang=js"
export * from "./MainWithoutFooterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__